import {SHA1} from 'crypto-js'
import tree from './tree'
import xtermjs from './xtermjs'
import electron from './electron'
import update from './update'
import sess from './sess'
import { dom, human, runtime } from "./utils-js"
import hotKey from "./hotKey"
import conf from "./conf"
import highlight from "./highlight"

// treeNode2FullPath 将 element v2 的 treeNode 节点转换成完整路径
function treeNode2FullPath(node) {
    let fullPath = ""
    let cNode = node
    let pNode = node.parent

    for (;pNode !== null;) {
      fullPath = cNode.data.name + "/" + fullPath
      cNode = pNode
      pNode = pNode.parent
    }
    return fullPath
}

function validateFileName(filename) {

    if (!filename || filename === "") {
        return "*"
    }

    let name = filename.trim()
    if (name.indexOf("/") >= 0 ) {
        return "不能包含 '/'"
    }

    return ""
}

function uuid() {
    let r = new Date() + Math.random()
    return SHA1(r).toString()
}

export default {
    tree,
    xtermjs,
    electron,
    update,
    sess,
    dom,
    human,
    hotKey,
    conf,
    highlight,
    runtime,
    treeNode2FullPath,
    domFocusById: dom.domFocusById,
    validateFileName,
    humanNum: human.num,
    humanBits: human.bits,
    humanSize: human.size,
    shortHumanTime: human.shortTime,
    formatTime: human.time,
    copyToClipboard: dom.copyToClipboard,
    downloadBlob: dom.downloadBlob,
    downloadText: dom.downloadText,
    printText: dom.printText,
    uuid,
}

export {tree, xtermjs, electron, update, sess, dom, human, hotKey, conf, runtime}
